// extracted by mini-css-extract-plugin
export var parallax = "section-module--parallax--ZdoiR";
export var sectionBg = "section-module--sectionBg--2odbz";
export var contentContainer = "section-module--contentContainer--PQGpD";